import React, { useState, useContext } from "react";
import "../../styles/styles.css";
import "../../../../styles/global.css";
import AccreditationInput from "../../../AccreditationInput/AccreditationInput";
import EventDateTimeRange from "../../../EventDateTimeRange/EventDateTimeRange";
import { apiRoutes } from "../../../../utils/apiRoutes";
import {
  createData,
  updateData,
  fetchData,
  deleteData,
} from "../../../../utils/methods";
import { useNavigate } from "react-router-dom";
import Modal from "../../Modal";
import ConfirmationModal from "../ConfirmationModal";
import EditModalShell from "../EditModalShell";
import { getDifferenceArrays } from "../../../../utils/perepateDataToEditEvent";
import { TranslationsContext } from "../../../../utils/TranslationsContext";
import { useEventData } from "../../../../hooks/useEventData";
import { trimValues } from "../../../../utils/trimValues";
import { useAlert } from "../../../../utils/AlertContext";
import useEnterKeySubmit from "../../../../hooks/useEnterKeySubmit";
import HistoryPanel from "../../../HistoryPanel/HistoryPanel";

// Build-time literal (unlike apiRoutes) so Terser can prove the History
// branch below is dead code on tiers other than Third. See EventGroup.jsx.
const TIER = process.env.REACT_APP_MODE;

const AddEvent = ({
  onCloseClick,
  object,
  editing,
  handleAddData,
  handleUpdateData,
  handleDeleteData,
}) => {
  const navigate = useNavigate();
  const {
    eventObject,
    setInputValue,
    isLoading,
    setIsLoading,
    verifiers,
    errors,
    setErrors,
    validateAllFields,
  } = useEventData({ editing, object, navigate });
  const [messageModalOpen, setMessageModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const { showAlert } = useAlert();

  console.log("eventObject", eventObject);

  const checkEventExist = async (object) => {
    try {
      setIsLoading(true);

      const result = await createData(
        apiRoutes.checkEventExist,
        object,
        showAlert,
        navigate,
        t,
      );
      if (!result) return;

      console.log(result.data);
      return result.data;
    } catch (err) {
      console.error("Error check event:", err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddClick = async () => {
    const noviObjekat = (({ naziv, trajanje_od, trajanje_do, lokacija }) => ({
      naziv,
      trajanje_od,
      trajanje_do,
      lokacija,
    }))(eventObject);
    const sendData = trimValues(noviObjekat);

    const response = await checkEventExist(sendData);
    console.log("naziv", response?.naziv);
    if (response?.naziv === null) {
      handleHoweverContinue();
    } else {
      setMessage(response?.naziv);
      setMessageModalOpen(true);
    }
  };

  const handleHoweverContinue = async () => {
    const verifikatori = eventObject.verifikatori?.map((obj) => obj.id);

    const podaciZaSlanje = {
      ...eventObject,
      // korisnici: idejevi,
      verifikatori,
      // dizajn,
    };

    // delete podaciZaSlanje.grupe;
    delete podaciZaSlanje.emailText;
    // delete podaciZaSlanje.template;
    console.log("podaci za slanje", podaciZaSlanje);

    setErrors();
    const isValid = validateAllFields();

    console.log("glreske", errors);
    console.log("slanje", podaciZaSlanje);

    if (!isValid) {
      console.log("Postoje greške u formi.");
      return;
    }

    setIsLoading(true);

    console.log("Dogadjaj dodavanje", podaciZaSlanje);

    try {
      const result = await createData(
        apiRoutes.addEvent,
        podaciZaSlanje,
        showAlert,
        navigate,
        t,
      );
      if (!result) return;

      console.log("Podaci su uspešno sačuvani:", result.data);
      handleAddData({ ...podaciZaSlanje, id: result.data?.id });
      showAlert(t("SUCCESSFULLY_SAVED"), "success");
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const addArrayInDB = async (array, route) => {
    console.log("dodavanjeNiz", array);
    console.log("dodavanjeRouta", route);
    setIsLoading(true);

    try {
      const result = await createData(route, array, showAlert, navigate, t);
      if (!result) return false;

      console.log("Podaci su uspešno sačuvani:", result.data);
      return true;
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeObjectInDB = async (object, route) => {
    console.log("promenaNiz", object);
    console.log("promenaRouta", route);
    setIsLoading(true);

    try {
      const result = await updateData(route, object, showAlert, navigate, t);
      if (!result) return false;

      console.log("Podaci su uspešno sačuvani:", result.data);
      return true;
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const processChanges = async (items, actionFn) => {
    if (items.length === 0) return true;

    const results = await Promise.all(items.map(actionFn));

    return results.every((res) => res === true);
  };

  const updateBasicFields = async () => {
    const keys = [
      "trajanje_od",
      "trajanje_do",
      "prijava_od",
      "prijava_do",
      "naziv",
      "lokacija",
      "lat",
      "lng",
    ];
    const changedValues = {};

    console.log("upored", eventObject, eventObject.oldObject);

    keys.forEach((key) => {
      const newVal = eventObject[key];
      const oldVal = eventObject.oldObject[key];

      const areDates = newVal instanceof Date && oldVal instanceof Date;

      if (areDates) {
        if (newVal.getTime() !== oldVal.getTime()) {
          changedValues[key] = newVal;
        }
      } else if (newVal !== oldVal) {
        changedValues[key] = newVal;
      }
    });

    console.log("promene", changedValues);

    if (Object.keys(changedValues).length > 0) {
      setErrors({});
      const isValid = validateAllFields();
      if (isValid) {
        const sendData = trimValues(changedValues);
        return await handleChangeObjectInDB(
          sendData,
          apiRoutes.updateEvent.replace(":eventId", eventObject.id),
        );
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const updateVerifikatori = async () => {
    let check_ver = true;
    const novi = eventObject.verifikatori?.map((obj) => obj.id) || [];
    const stari =
      eventObject.oldObject.verifikatori?.map((obj) => obj.id) || [];

    const { toAdd, toDelete } = getDifferenceArrays(stari, novi);

    console.log("check_ver 0", check_ver);

    // Ako neka od funkcija vrati false, prekida dalji rad
    check_ver = await processChanges(toAdd, async (id) => {
      if (!check_ver) return false;
      return await addArrayInDB(
        { action: "add", dogadjajId: eventObject.id, verifikatorId: id },
        apiRoutes.addEventVerifiers,
      );
    });

    console.log("check_ver 1", check_ver);

    if (!check_ver) return false;

    check_ver = await processChanges(toDelete, async (id) => {
      if (!check_ver) return false;
      return await addArrayInDB(
        { action: "delete", dogadjajId: eventObject.id, verifikatorId: id },
        apiRoutes.deleteEventVerifiers,
      );
    });

    console.log("check_ver 2", check_ver);

    return check_ver;
  };

  const reloadEvent = async () => {
    try {
      setIsLoading(true);

      const result = await fetchData(
        apiRoutes.getEventById.replace(":eventId", eventObject.id),
        showAlert,
        navigate,
        t,
      );

      if (!result) return null;

      const { data } = result;
      return data;
    } catch (err) {
      console.error("Error fetching events:", err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteClick = async () => {
    const route = apiRoutes.deleteEvent.replace(":eventId", object.id);
    setIsLoading(true);
    try {
      const result = await deleteData(route, null, showAlert, navigate, t);
      if (!result) return;

      handleDeleteData?.(object.id);
      showAlert(t("SUCCESSFULLY_DELETED"), "success");
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
      setIsConfirmDeleteOpen(false);
    }
  };

  const handleSaveClick = async () => {
    try {
      setIsLoading(true);

      const basicFieldsUpdated = await updateBasicFields();
      if (!basicFieldsUpdated) {
        showAlert(t("ERROR_UPDATE_BASIC_FIELDS"), "error");
        return;
      }

      const verifikatoriUpdated = await updateVerifikatori();
      if (!verifikatoriUpdated) {
        showAlert(t("ERROR_UPDATE_VERIFIERS"), "error");
        return;
      }

      const updatedEvent = await reloadEvent();
      await handleUpdateData({ ...updatedEvent, id: eventObject.id });

      showAlert(t("SUCCESSFULLY_SAVED"), "success");
      onCloseClick();
    } catch (error) {
      console.error("Greška:", error);
      showAlert("Došlo je do greške prilikom čuvanja podataka.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const { t } = useContext(TranslationsContext);

  useEnterKeySubmit(editing ? handleSaveClick : handleAddClick);

  return (
    <>
      <EditModalShell
        isLoading={isLoading}
        t={t}
        headerInfo={
          <p className="inria-sans-400 font-24 modal-title">
            {editing ? t("EDIT_EVENT_TITLE") : t("ADD_EVENT_TITLE")}
          </p>
        }
        onSave={editing ? handleSaveClick : handleAddClick}
        onClose={onCloseClick}
        onDelete={
          editing && apiRoutes.deleteEvent
            ? () => setIsConfirmDeleteOpen(true)
            : undefined
        }
        sidePanel={
          <>
            <div className="flex-direction-column gap-24 width-100 side-panel-card">
              <div className="flex-direction-row gap-48 width-100 modal-two-inputs-inline">
                <AccreditationInput
                  label={t("LAT")}
                  className="modal-input"
                  setInputValue={(value) =>
                    setInputValue("lat", value === "" ? null : Number(value))
                  }
                  value={eventObject.lat ?? null}
                  error={errors?.lat}
                  type="lat"
                />
                <AccreditationInput
                  label={t("LNG")}
                  className="modal-input"
                  setInputValue={(value) =>
                    setInputValue("lng", value === "" ? null : Number(value))
                  }
                  value={eventObject.lng ?? null}
                  error={errors?.lng}
                  type="lng"
                />
              </div>
              {verifiers && verifiers.length > 0 && (
                <AccreditationInput
                  type="tag"
                  tags={eventObject.verifikatori}
                  onTagsChange={(newTags) =>
                    setInputValue("verifikatori", newTags)
                  }
                  placeholder={t("ADD_ENTITIRS_PLH")}
                  label={t("VERIFICATION_LABEL")}
                  suggestions={verifiers}
                />
              )}
            </div>
            {editing && TIER === "third" && (
              <HistoryPanel tabela="dogadjaji" redId={object?.id} />
            )}
          </>
        }
      >
        <div className="flex-direction-column gap-24 width-100 modal-content">
          <div className="width-100">
            <AccreditationInput
              className="modal-input"
              required={true}
              label={t("NAME_1")}
              setInputValue={(value) => setInputValue("naziv", value)}
              value={eventObject.naziv}
              error={errors?.naziv}
            />
          </div>
          <div className="width-100">
            <AccreditationInput
              className="modal-input"
              required={true}
              label={t("LOCATION")}
              setInputValue={(value) => setInputValue("lokacija", value)}
              value={eventObject.lokacija}
              error={errors?.lokacija}
            />
          </div>
          {/* Dates + times in Belgrade time (EventDateTimeRange). */}
          <EventDateTimeRange
            label={t("EVENT_DURATION")}
            required
            from={eventObject.trajanje_od}
            to={eventObject.trajanje_do}
            onChange={(from, to) => {
              setInputValue("trajanje_od", from);
              setInputValue("trajanje_do", to);
            }}
            error={errors?.trajanje_od || errors?.trajanje_do}
          />
          <EventDateTimeRange
            label={t("REGISTRATION_PERIOD")}
            required
            from={eventObject.prijava_od}
            to={eventObject.prijava_do}
            onChange={(from, to) => {
              setInputValue("prijava_od", from);
              setInputValue("prijava_do", to);
            }}
            error={errors?.prijava_od || errors?.prijava_do}
          />
        </div>
      </EditModalShell>

      {messageModalOpen && (
        <Modal
          type="message"
          message={message}
          onCloseClick={() => setMessageModalOpen(false)}
          onClick={() => handleHoweverContinue()}
        />
      )}

      {isConfirmDeleteOpen && (
        <ConfirmationModal
          handleDeclineClick={() => setIsConfirmDeleteOpen(false)}
          handleConfirmClick={() => handleDeleteClick()}
          term={eventObject.naziv}
        />
      )}
    </>
  );
};

export default AddEvent;
